import { associatedInfo, tmMedia, tmSubjects, tmThemes } from '@/queries/TeachingMaterialsFragments';
import gql from 'graphql-tag';

export const teachingMaterialsTopicQuery = gql`
  query getTopic($slug: String) {
    tmTopics(where: { slugName: $slug }) {
      nodes {
        ${associatedInfo}
        associatedTopics {
          topic {
            ${associatedInfo}
            databaseId
            excerpt
            featuredImage {
              node {
                altText
                mediaDetails {
                  height
                  width
                }
                sourceUrl
              }
            }
            imageSrcset
            packageParent {
              slug
            }
            title
          }
        }
        content
        excerpt
        featuredImage {
          node {
            altText
            sourceUrl
          }
        }
        imageSrcset
        packageParent {
          slug
          title
        }
        relatedMaterials {
          ... on Tm_package {
            __typename
            associatedTopics {
              topic {
                ${associatedInfo}
              }
            }
            excerpt
            featuredImage {
              node {
                altText
                sourceUrl
              }
            }
            imageSrcset
            imageCount
            slug
            title
            tmPackagePageElements {
              whats_included
            }
            videoCount
          }
          ... on Tm_topic {
            __typename
            caCount
            excerpt
            featuredImage {
              node {
                altText
                sourceUrl
              }
            }
            imageSrcset
            imageCount
            packageParent {
              slug
            }
            slug
            title
            vdCount
            videoCount
          }
        }
        ${tmMedia}
        ${tmSubjects}
        ${tmThemes}
        title
        tmArtistInfo {
          audio_file
          bio
          pronounciation_guide
        }
        tmData {
          type
          content {
            __typename
            links {
              image
              label
              video
            }
            text
            title
          }
        }
        tmGallery
        tmTopicPageElements {
          all_resources {
            header
            resources
          }
          key_terms {
            header
            terms {
              __typename
              term
              title
            }
          }
          pdf
        }
        databaseId
        tmType
      }
    }
  }
`;
